import type { HTMLAttributes, PropsWithChildren, ReactNode } from "react";

import Link from "next/link";

import type { ButtonSize } from "@/src/components/ui/Button/buttonClassName";

import { isExternal } from "@/src/app/externalLinks";
import { buttonClassName } from "@/src/components/ui/Button/buttonClassName";

type ButtonLinkProps = PropsWithChildren<
  {
    readonly darkBackground?: boolean;
    readonly href: string;
    readonly size: ButtonSize;
  } & HTMLAttributes<HTMLAnchorElement>
>;

export function ButtonLink({
  children,
  className,
  darkBackground = false,
  href,
  size,
}: ButtonLinkProps): ReactNode {
  const classNames = buttonClassName(className, darkBackground, false, size);
  return isExternal(href) ? (
    <a className={classNames} href={href}>
      {children}
    </a>
  ) : (
    <Link className={classNames} href={href}>
      {children}
    </Link>
  );
}
